import { render, staticRenderFns } from "./ProjectWorkorderEdit.vue?vue&type=template&id=0585b060"
import script from "./ProjectWorkorderEdit.vue?vue&type=script&lang=js"
export * from "./ProjectWorkorderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports